export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#1A1F36] rounded-t-[40px]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/1b77b62f-3787-44d3-a822-0a6da43397f6.png" 
                alt="SALINAS S.R.L. Logo" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold text-white">SALINAS S.R.L.</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Protecting your digital freedom
            </p>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-6">QUICK LINKS</h3>
            <div className="space-y-3">
              <button
                onClick={() => scrollToSection('home')}
                className="block text-gray-400 hover:text-[#00D4AA] transition-colors cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-gray-400 hover:text-[#00D4AA] transition-colors cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('vpn-service')}
                className="block text-gray-400 hover:text-[#00D4AA] transition-colors cursor-pointer"
              >
                VPN Service
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="block text-gray-400 hover:text-[#00D4AA] transition-colors cursor-pointer"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-gray-400 hover:text-[#00D4AA] transition-colors cursor-pointer"
              >
                Contact
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-6">CONTACT INFO</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-gray-400">
                <i className="ri-mail-line text-[#00D4AA]"></i>
                <span className="text-sm">contact@salinassrl.com</span>
              </div>
              <div className="flex items-center gap-3 text-gray-400">
                <i className="ri-phone-line text-[#00D4AA]"></i>
                <span className="text-sm">+1 5707156139</span>
              </div>
              <div className="flex items-start gap-3 text-gray-400">
                <i className="ri-map-pin-line text-[#00D4AA] mt-1"></i>
                <span className="text-sm">BV. RACEDO 599, Paraná, E3100IDT, Argentina</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#00D4AA]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 SALINAS S.R.L. All rights reserved
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#00D4AA] text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
